<template>
	<span v-if="showPill" class="new-alert-pill">
		<span>{{ $t("overlay-menu.new") }}</span>
	</span>
	<span v-else class="new-alert-badge">{{ $t("overlay-menu.new") }}</span>
</template>

<script>
export default {
	name: "new-badge-indicator",
	props: {
		showPill: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
.new-alert-badge {
	position: absolute;
	font-size: var(--font-tiny);
	font-weight: var(--font-weight-normal);
	text-transform: none;
	padding-top: 1px;
	color: var(--always-white);
	background: transparent url("../../assets/img/new_badge.png") no-repeat;
	background-size: 35px 16px;
	width: auto;
	min-width: 23px;
	height: 27px;
	text-align: center;
}
.new-alert-pill{
	width: 30px;
	height: 16px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 10px;
	border-radius: 4px;
	background-color: var(--red-3);
	color: var(--always-white);
	font-size: 9px;
	font-style: normal;
	font-weight: 400;
	line-height: 20px;
	padding: 0;

}
</style>
